import { NamespaceStateEnum } from "@/__generated__/graphql";
import BadgeDot from "@/components/shared/BadgeDot";
import StateBadge from "@/components/StateBadges/StateBadge";

function colorForState(state: NamespaceStateEnum) {
  switch (state) {
    case NamespaceStateEnum.Activating:
    case NamespaceStateEnum.Initialized:
      return "yellow";
    case NamespaceStateEnum.Active:
      return "green";
    case NamespaceStateEnum.Deactivating:
    case NamespaceStateEnum.Deactivated:
    case NamespaceStateEnum.Errored:
      return "red";
    case NamespaceStateEnum.Removed:
    case NamespaceStateEnum.Removing:
      return "gray";
    default:
      throw new Error(`Unknown namespace state: ${state}`);
  }
}

export default function NamespaceStateBadge({ state }: { state?: NamespaceStateEnum }) {
  if (typeof state === "undefined") return null;

  return (
    <StateBadge
      badgeDot={<BadgeDot variant={colorForState(state)} />}
      spinnerVisibleOnStates={[
        NamespaceStateEnum.Activating,
        NamespaceStateEnum.Deactivating,
        NamespaceStateEnum.Removing,
      ]}
      state={state}
    />
  );
}
